import { cn } from '../lib/cn';

import type { HTMLAttributes } from 'react';

type Tone = 'neutral' | 'primary' | 'inverse' | 'success' | 'warning';

const tones: Record<Tone, string> = {
  neutral: 'bg-surface text-fg-muted',
  primary: 'bg-accent-soft text-accent',
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning',
  inverse: 'bg-fg text-canvas',
};

export function Pill({
  tone = 'neutral',
  className,
  ...rest
}: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={cn(
        'inline-flex h-6 items-center gap-1.5 rounded-md px-2 text-xs font-medium',
        tones[tone],
        className,
      )}
      {...rest}
    />
  );
}
